/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_uk_117_107(e) {
  let t = (0, ReactCompiler.c)(5),
    { valor: n, ancho: r } = e,
    i = `h-1.5 ${r === void 0 ? `w-20` : r} shrink-0 overflow-hidden rounded-full bg-(--panel)`,
    a = `${n}%`,
    o;
  t[0] === a
    ? (o = t[1])
    : ((o = (
        <div
          className={`h-full rounded-full bg-(--accent)`}
          style={{
            width: a,
          }}
        />
      )),
      (t[0] = a),
      (t[1] = o));
  let s;
  return (
    t[2] !== i || t[3] !== o
      ? ((s = <div className={i} children={o} />),
        (t[2] = i),
        (t[3] = o),
        (t[4] = s))
      : (s = t[4]),
    s
  );
}
